<app-modal
  title="{{ 'Show moved' | trans:'shows/show-moved-modal/header/title' }}"
  maxWidth="480px"
  width="100%"
>
  <ng-template>
    <p class="p1">
      {{ 'This show has been moved. Please refresh the page to load the current show list.' | trans:'shows/show-moved-modal/message.Text' }}
    </p>
  </ng-template>

  <ng-container modal-buttons>
    <div class="d-flex gap-16 m-t-16 justify-content-flex-end">
      <button
        class="button button--md button--primary text-uppercase"
        type="button"
        (click)="refreshPage()"
      >
        {{ 'Refresh page' | trans:'shows/show-moved-modal/refresh.Button' }}
      </button>
    </div>
  </ng-container>
</app-modal>
